import { useMutation } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse } from 'services/requests';
import { Parameters } from 'constants/queryParameters';
import { MutationKeys } from 'constants/mutationKeys';

export const useUnsubscribe = () => {
  const accessKey = useSearchParams()[0].get(Parameters.accessKey);

  const mutate = async () => {
    const { data } = await api.unsubscribeInvitation(accessKey ?? '');

    return data;
  };

  const mutationKey = MutationKeys.unsubscribeEmail;

  return useMutation<SuccessResponse, AxiosError<ApiError>>(mutationKey, mutate);
};
